export type SkillMention = { id: string; label: string };
export type SkillMentionChunk = { type: "text"; value: string } | { type: "skill"; value: SkillMention };

const encodeTokenPart = (value: string) => value.replace(/[%[\]|\r\n]/g, (character) => encodeURIComponent(character));

export function serializeSkillMentionToken({ id, label }: SkillMention): string {
  return `/skill[${encodeTokenPart(id)}|${encodeTokenPart(label || id)}]`;
}

export function parseSkillMentionChunks(content: string): SkillMentionChunk[] {
  const chunks: SkillMentionChunk[] = [];
  let lastIndex = 0;
  for (const match of content.matchAll(/\/skill\[([^\s[\]|]+)\|([^\r\n[\]|]*)\]/g)) {
    let mention: SkillMention;
    try {
      const id = decodeURIComponent(match[1]!);
      mention = { id, label: decodeURIComponent(match[2]!) || id };
    } catch {
      continue;
    }
    const start = match.index;
    if (start > lastIndex) chunks.push({ type: "text", value: content.slice(lastIndex, start) });
    chunks.push({ type: "skill", value: mention });
    lastIndex = start + match[0].length;
  }
  if (lastIndex < content.length) chunks.push({ type: "text", value: content.slice(lastIndex) });
  return chunks.length ? chunks : [{ type: "text", value: content }];
}

export function getReferencedSkillIds(content: string): string[] {
  return [
    ...new Set(parseSkillMentionChunks(content).flatMap((chunk) => (chunk.type === "skill" ? [chunk.value.id] : []))),
  ];
}
